export const PMS_INTEGRATIONS_ACTION_TYPES = {
    GET_OCTORATE_USER_INFO_SUCCESS: "GET_OCTORATE_USER_INFO_SUCCESS",
}